import { isHaddockHostname } from "./haddockDomain";

/**
 * Verifica si un archivo es compatible para firma con Signaturit
 * @param {string} filename - Nombre del archivo
 * @returns {boolean} - true si el archivo es compatible
 */
export const isSignableDocument = (filename) => {
    if (!filename) return false;
    
    const extension = filename.toLowerCase().split('.').pop();
    const allowedExtensions = ['pdf', 'doc', 'docx'];
    
    return allowedExtensions.includes(extension);
};

/**
 * Obtiene los formatos permitidos para firma
 * @returns {string} - Lista de formatos permitidos
 */
export const getAllowedFormats = () => {
    return 'PDF, DOC, DOCX';
};

/**
 * Obtiene el mensaje de error para formatos no permitidos
 * @param {string} filename - Nombre del archivo
 * @returns {string} - Mensaje de error
 */
export const getFormatErrorMessage = (filename) => {
    const extension = filename ? filename.toLowerCase().split('.').pop() : '';
    return `El formato "${extension.toUpperCase()}" no es compatible con la firma digital. Formatos permitidos: ${getAllowedFormats()}`;
};

/**
 * Verifica si el usuario está en un entorno de Haddock
 * @returns {boolean} - true si está en Haddock
 */
export const isHaddockEnvironment = () => {
    const domain = window.location.hostname;
    const isHaddockDomain = isHaddockHostname(domain);
    
    // También verificar si viene de Haddock (cookie)
    const { authService } = require('services');
    const isFromHaddock = authService.isFromHaddock || authService.isHaddockDomain;
    
    return isHaddockDomain || isFromHaddock;
};
